import React, { Component } from 'react'
import PropTypes from 'prop-types'
import classnames from 'classnames'

import IconButton from '../../common/common/icon_button/icon_button.jsx'

class Arrow extends Component {
  static displayName = 'Arrow'

  static propTypes = {
    direction: PropTypes.string,
    show: PropTypes.bool.isRequired,
    onClick: PropTypes.func,
    top: PropTypes.number,
    left: PropTypes.number,
    relative: PropTypes.bool
  }

  render () {
    const direction = this.props.direction || 'left'

    const className = classnames(
      'horizontal-scrolling',
      {
        disable: !this.props.show
      },
      `horizontal-scrolling_${direction}`
    )

    const top = this.props.top || 0
    const left = this.props.left || 0
    const position = this.props.relative ? 'absolute' : 'fixed'
    const style = { top: top, left: left, position: position }

    let iconName = 'common-rightarw'
    let title = 'common.dashboard.scrollPrev'
    if (direction === 'right') {
      iconName = 'common-leftarw'
      title = 'common.dashboard.scrollNext'
    }

    return (
      <IconButton
        icon={iconName}
        title={title}
        canHover={false}
        style={style}
        size='big'
        className={className}
        onClick={this.props.onClick}
      />
    )
  }
}

export default Arrow
